import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, queryClient, QueryConfig } from 'lib/react-query';

import { Analyzer } from 'types';

export const getAnalyzer = async (
  analyzerId: number
): Promise<Analyzer | undefined> => {
  if (analyzerId < 1) return;
  const { data } = await axios.get(`/api/analyzers/${analyzerId}`);

  return data as Analyzer;
};

export const getInitialData = (analyzerId: number) => {
  const analyzers: Analyzer[] | undefined = queryClient.getQueryData([
    'analyzers',
  ]);
  return analyzers?.find((analyzer) => analyzer.id === analyzerId);
};

type QueryFnType = typeof getAnalyzer;

type UseAnalyzerOptions = {
  analyzerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useAnalyzer = ({ analyzerId, config }: UseAnalyzerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    initialData: () => getInitialData(analyzerId),
    queryKey: ['analyzer', analyzerId],
    queryFn: () => getAnalyzer(analyzerId),
  });
};
